import React from 'react';
import PropTypes from 'prop-types';
import BusComponent from '../../BusComponent';
import SimpleStepContent from './SimpleStepContent';
import LocationAnalysisItem from '../../../objects/LocationAnalysisItem';
import { HELP_TOUR_DEFAULT_FACILITY } from '../../../enums/HelpTourDefinitions';

class InfoPanelStep extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            stepId: this.props.stepId,
            report: this.props.report,
        };
    }

    get bus() {
        return this.props.bus || this.context.bus;
    }

    componentDidMount() {
        this.bindGluBusEvents({
            MAP_VIEWER: this.onMapViewer,
            INSIGHTS_STATE: this.onInfoPanelState,
            INSIGHTS_REPORT_UPDATED: this.onInsightsReportUpdated,
        });
        this.emit('INSIGHTS_STATE_REQUEST');
    }

    componentDidUpdate() {
        if (this.props.stepId !== this.state.stepId) {
            this.setState({ stepId: this.props.stepId });
            this.emit('INSIGHTS_STATE_REQUEST');
        }
        if(this.props.report !== this.state.report) {
            this.setState({ report: this.props.report });
            this.emit('INSIGHTS_REPORT_UPDATE_REQUEST', { report: this.props.report });
        }
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onMapViewer = ({ source }) => {
        this.openMoreInfo(source.id);
    };

    onInfoPanelState = ({ open }) => {
        if (open) {
            this.emit('HELP_TOUR_STEP_LOADED');
        } else {
            this.emit('MAP_GET_MAP_VIEWER');
        }
    };
    
    onInsightsReportUpdated = () => {
        this.emit('HELP_TOUR_STEP_LOADED');
    };

    openMoreInfo = mapInstanceId => {
        const newLocationAnalysisItem = new LocationAnalysisItem(HELP_TOUR_DEFAULT_FACILITY);

        const visualReportProps = {
            report: this.state.report,
            pointType: newLocationAnalysisItem.type,
            facilityId: newLocationAnalysisItem.id,
        };

        this.emit('ENTER_UPDATE_LOCATION_ANALYSIS_MODE', {
            selectedItem: newLocationAnalysisItem,
            mapInstanceId,
            showInsights: true,
            visualReportProps,
        });
    };

    render() {
        const { content } = this.props;

        return <SimpleStepContent content={content} />;
    }
}

InfoPanelStep.propTypes = {
    stepId: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    report: PropTypes.string,
};

InfoPanelStep.defaultProps = {
    report: 'selfstorage-point-info',
};

export default InfoPanelStep;
